function validateUrl(link: string): string {
  return link.indexOf("http://") == 0 || link.indexOf("https://") == 0
    ? link
    : `https://${link}`;
}

export default validateUrl;
